export default {
  overcapGain: 'Einkommen ist durch Überkapazität auf {0}% reduziert',
  overcapNoGain: 'Kein Einkommen aufgrund von Überkapazität',
  benefitLoss: 'Der Kauf führt zum Verlust von Vorteilen',
  gainTimerNeeded: 'Kaufbar in {0}',
  capTimerNeeded: 'Kapazität erreicht in {0}',
  overcapTimerNeeded: 'Nächste Kapazitätsstufe erreicht in {0}',

  // Premium currencies
  gem_ruby: {
    name: 'Rubin',
    description: 'Ein strahlender roter Edelstein, der für starke permanente Verbesserungen eingetauscht werden kann'
  },
  gem_emerald: {
    name: 'Smaragd',
    description: 'Ein blasser grüner Edelstein, der für verschiedene Aufwertungen verwendet wird. Die Dorfbewohner scheinen ihn zu mögen'
  },
  gem_sapphire: {
    name: 'Saphir',
    description: 'Ein dunkler blauer Edelstein der zum Tausch für Verbrauchsgüter verwendet werden kann, die deinen Fortschritt beschleunigen'
  },
  gem_amethyst: {
    name: 'Amethyst',
    description: 'Dieser schöne lila Edelstein kann für Farbschemen oder andere optische Aufwertungen eingetauscht werden'
  },
  gem_topaz: {
    name: 'Topas',
    description: 'Ein gelber Edelstein, der deine Leistung in Events verbessert oder die Teilnahme ermöglicht. Wenn ein großes Event stattfindet, erzeugt der Edelsteingenerator kein Topas. Du erhältst stattdessen eine eventspezifische Währung'
  },
  gem_diamond: {
    name: 'Diamant',
    description: ''
  },
  gem_onyx: {
    name: 'Onyx',
    description: ''
  },

  // Event currencies
  event_wax: {
    name: 'Wachs',
    description: 'Natürliches Wachs zum Gießen von Kerzen'
  },
  event_humus: {
    name: 'Humus',
    description: 'Deine Blumen lieben diesen frischen und fruchtbaren Boden'
  },
  event_cloud: {
    name: 'Wolke',
    description: 'Eine winzige Wolke, gefangen in einer Flasche'
  },
  event_cocktail: {
    name: 'Cocktail',
    description: 'Du würdest diese gern selbst trinken, aber sie sind ein exzellenter Ansporn für die Bauarbeiter'
  },
  event_magic: {
    name: 'Magie',
    description: 'Magie wird langsam verbraucht, um andere Währungen in magische Währungen umzuwandeln. Je mehr Magie du hast, desto schneller der Prozess. Magische Währungen können am ungewöhnlichen Symbol erkannt werden. Um sie zurückzuverwandeln, fahre mit der Maus hinüber, das bringt ebenfalls Zutaten'
  },
  event_snowball: {
    name: 'Schneeball',
    description: 'Fang!'
  },
  event_cindersToken: {
    name: 'Abendlicht-Chip',
    description: 'Belohnung für das Erreichen einer gewissen Lichtmenge'
  },
  event_bloomToken: {
    name: 'Erblühen-Chip',
    description: 'Belohnung für neue Stufenrekorde pro Blumenart'
  },
  event_weatherChaosToken: {
    name: 'Wetterchaos-Chip',
    description: 'Belohnung für neue Größenrekorde pro Fischart'
  },
  event_summerFestivalToken: {
    name: 'Sommerfestival-Chip',
    description: 'Belohnung für das Erfüllen von Aufgaben'
  },
  event_nightHuntToken: {
    name: 'Nachtjagd-Chip',
    description: 'Belohnung für neue Trankstufen oder neue erfolgreiche Rituale'
  },
  event_snowdownToken: {
    name: 'Schneefall-Chip',
    description: 'Belohnung für das Gewinnen von Schneeballschlachten'
  },
  event_light: {
    name: 'Licht',
    description: 'Brenn noch heller'
  },
  event_soot: {
    name: 'Ruß',
    description: 'Von heruntergebrannten Kerzen zurückgelassen'
  },
  event_blossom: {
    name: 'Blüte',
    description: 'Sie sind zwar schön, sehen aber alle gleich aus'
  },
  event_algae: {
    name: 'Algen',
    description: 'Grün und schleimig'
  },
  event_driftwood: {
    name: 'Treibholz',
    description: 'Du weißt zwar nicht, wo es herkommt, es sieht aber brauchbar aus'
  },
  event_plastic: {
    name: 'Plastik',
    description: 'Warum treibt hier so viel Müll herum?'
  },
  event_slime: {
    name: 'Schleim',
    description: 'Und du dachtest, Algen wären schleimig'
  },
  event_log: {
    name: 'Baumstamm',
    description: 'Ein grundlegendes Baumaterial'
  },
  event_stoneBlock: {
    name: 'Steinblock',
    description: 'Aus dem Berg geschnitten'
  },
  event_coconut: {
    name: 'Kokosnuss',
    description: 'Harte Nuss'
  },
  event_shell: {
    name: 'Muschel',
    description: 'Muscheln, die du am Strand gefunden hast'
  },
  event_music: {
    name: 'Musik',
    description: 'Das nennst du Musik?'
  },
  event_sand: {
    name: 'Sand',
    description: 'Sand, so weit das Auge sehen kann'
  },
  event_freshWater: {
    name: 'Frisches Wasser',
    description: 'Frisch und gefiltert'
  },
  event_coal: {
    name: 'Kohle',
    description: 'Eine Ressource, die gerne zum Grillen verwendet wird'
  },
  event_metalPart: {
    name: 'Metallteil',
    description: 'Manche nennen es Abfall, andere nennen es einen Schatz'
  },
  event_pearl: {
    name: 'Pearl',
    description: 'Eine seltene Perle aus einer Muschel'
  },
  event_salt: {
    name: 'Salz',
    description: 'Salzig?'
  },
  event_pepper: {
    name: 'Pfeffer',
    description: 'Perfekt zum Würzen von Gerichten'
  },
  event_honey: {
    name: 'Honig',
    description: 'Wie süß'
  },
  event_vegetable: {
    name: 'Gemüse',
    description: 'Nahrhaft und eventuell auch lecker'
  },
  event_citrusFruit: {
    name: 'Zitrusfrucht',
    description: 'Süß und sauer'
  },
  event_rawFish: {
    name: 'Roher Fisch',
    description: 'Frisch aus dem Ozean'
  },
  event_cookedFish: {
    name: 'Bratfisch',
    description: 'Zitronen würden hier super zu passen'
  },
  event_rawMeat: {
    name: 'Rohes Fleisch',
    description: 'Frisch aus dem Wald'
  },
  event_cookedMeat: {
    name: 'Gebratenes Fleisch',
    description: 'Nur noch etwas Salz und Pfeffer'
  },
  event_solidPlate: {
    name: 'Bauplatte',
    description: 'Ein häufig verwendetes Baumaterial aus Holz und Stein'
  },
  event_sandstone: {
    name: 'Sandstein',
    description: 'Sieht aus wie Sand, verhält sich aber wie Stein'
  },
  event_hardSteel: {
    name: 'Edelstahl',
    description: 'Rostfrei und noch härter als gewöhnlicher Stahl'
  },
  event_compositePlate: {
    name: 'Zusammengefügte Platte',
    description: 'Du hattest die Idee, alle Baumaterialien zusammenzupressen und es... funktioniert!'
  },
  event_coconutSalad: {
    name: 'Kokossalat',
    description: 'Frisch und einfach'
  },
  event_saltyShell: {
    name: 'Salzige Muscheln',
    description: 'Es ist... nicht für jedermann'
  },
  event_lemonCandy: {
    name: 'Zitronenbonbon',
    description: 'Kinder lieben diese'
  },
  event_steak: {
    name: 'Steak',
    description: 'Perfekt durchgebraten'
  },
  event_fishSticks: {
    name: 'Fischstäbchen',
    description: 'Ein zeitloser Klassiker'
  },
  event_essence: {
    name: 'Essenz',
    description: 'Eine seltsame Flüssigkeit mit enormer verborgener Kraft'
  },
  event_lavender: {
    name: 'Lavendel',
    description: 'Im Wald gefunden'
  },
  event_mapleLeaf: {
    name: 'Ahornblatt',
    description: 'Seltsam, es sind keine Ahornbäume in Sichtweite'
  },
  event_fourLeafClover: {
    name: 'Vierblättriges Kleeblatt',
    description: 'Glückskind!'
  },
  event_charredSkull: {
    name: 'Verkohlter Schädel',
    description: 'Die Knochen sind nicht nur verbrannt, sondern auch extrem alt'
  },
  event_mysticalWater: {
    name: 'Mystisches Wasser',
    description: 'Es sieht wie gewöhnliches Wasser aus, nur etwas heller'
  },
  event_cheese: {
    name: 'Käse',
    description: 'Die meisten Leute würden ihn essen, aber er ist auch für magische Zwecke nützlich'
  },
  event_spiderWeb: {
    name: 'Spinnennetz',
    description: 'Scheint verlassen zu sein, also gehört es wohl dir'
  },
  event_strangeEgg: {
    name: 'Seltsames Ei',
    description: 'Was ist das? Zu welchem Lebewesen gehört es? Naja, ab in den Kessel mit dir!'
  },
  event_puzzlePiece: {
    name: 'Puzzleteil',
    description: 'Es kann logische Rätsel lösen, aber gilt das auch für magische Rätsel?'
  },
  event_wizardHat: {
    name: 'Magierhut',
    description: 'Top-Outfit!'
  },
  event_cactus: {
    name: 'Kaktus',
    description: 'Nicht anfassen'
  },
  event_feather: {
    name: 'Feder',
    description: 'Eindeutig kein Schwergewicht'
  },
  event_dough: {
    name: 'Teig',
    description: 'Warum Kekse essen wenn man auch gleich den Teig essen kann?'
  },
  event_cinnamon: {
    name: 'Zimt',
    description: 'Was wäre ein Winter nur ohne Zimt?'
  },
  event_sapling: {
    name: 'Setzling',
    description: 'Gewöhnliche Tannensetzlinge. Mit genug Zeit können daraus riesige Tannen werden'
  },
  event_water: {
    name: 'Wasser',
    description: 'Sauberes und kaltes Wasser aus dem Hahn'
  },
  event_snow: {
    name: 'Schnee',
    description: 'Er ist kalt, überall, und mit genug davon kann man ganze Schneemänner bauen'
  },
  event_yarn: {
    name: 'Garn',
    description: 'Damit jeder es warm und gemütlich hat'
  },

  // Feature currencies
  mining_scrap: {
    name: 'Schrott',
    description: 'Aus irgendeinem Grund ist hier unten alles voller Schrott! Das muss aber nichts Schlechtes sein, Schrott ist vielseitig und kann für fast alles verwendet werden'
  },
  mining_oreAluminium: {
    name: 'Aluminiumerz',
    description: 'Endlich etwas, das kein Schrott ist. In der unverarbeiteten Form ist der Nutzen begrenzt, das heißt aber noch lange nicht nutzlos'
  },
  mining_oreCopper: {
    name: 'Kupfererz',
    description: 'Ein weiteres der fehlenden Erze. Das hier scheint bessere Ergebnisse zu erzielen, als das Letzte. Wie viele andere sind noch hier unten?'
  },
  mining_oreTin: {
    name: 'Zinnerz',
    description: 'Ein helles Material ist eine willkommene Abwechslung zur Dunkelheit in diesen Tiefen. Das Loch zur Oberfläche ist kaum noch zu sehen'
  },
  mining_oreIron: {
    name: 'Eisenerz',
    description: 'Ein hartes und robustes Material. Es erinnert dich an Teile aus dem Schrott hier unten'
  },
  mining_oreTitanium: {
    name: 'Titanerz',
    description: 'Mit Eisen verglichen wirkt dieser Rohstoff nahezu unzerstörbar. Das könnte dir bei der Konstruktion einiger Dinge helfen, wo andere Erze nicht stabil genug waren'
  },
  mining_orePlatinum: {
    name: 'Platinerz',
    description: 'Dieses Erz sieht sehr schön aus, wenn man es ein wenig poliert. Hoffentlich ist es nicht nur schön, sondern auch nützlich'
  },
  mining_oreIridium: {
    name: 'Iridiumerz',
    description: 'Irid... was? Der Name sagt dir nichts, hat es überhaupt einen Nutzen?'
  },
  mining_oreOsmium: {
    name: 'Osmiumerz',
    description: ''
  },
  mining_oreLead: {
    name: 'Bleierz',
    description: ''
  },
  mining_granite: {
    name: 'Granit',
    description: 'Massive Granitblöcke, aus dem Untergrund geschnitten. Überraschenderweise sind sie komplett schrottfrei'
  },
  mining_salt: {
    name: 'Salz',
    description: 'Dieses Salz ist nicht zum Essen da, es schmeckt bitter. Lieber damit Erze einschmelzen'
  },
  mining_coal: {
    name: 'Kohle',
    description: 'Dieser Rohstoff scheint selten zu sein, nach dem Abbauen konntest du keine weiteren auf der Tiefe finden wie bei den Erzen'
  },
  mining_sulfur: {
    name: 'Schwefel',
    description: 'Hell und gelb'
  },
  mining_niter: {
    name: 'Salpeter',
    description: 'Noch ein seltener Rohstoff, der hier ist auch begrenzt'
  },
  mining_obsidian: {
    name: 'Obsidian',
    description: 'Wunderschöne lila Scherben, sie sehen zerbrechlich aus'
  },
  mining_deeprock: {
    name: 'Tiefenstein',
    description: ''
  },
  mining_glowshard: {
    name: 'Leuchtscherbe',
    description: ''
  },
  mining_barAluminium: {
    name: 'Aluminiumbarren',
    description: 'Der Erste von vielen'
  },
  mining_barBronze: {
    name: 'Bronzebarren',
    description: 'Mehr als die Summe der Bestandteile'
  },
  mining_barSteel: {
    name: 'Stahlbarren',
    description: 'Verstärktes Eisen'
  },
  mining_barTitanium: {
    name: 'Titanbarren',
    description: 'Extrem haltbar und resistent'
  },
  mining_barShiny: {
    name: 'Glanzbarren',
    description: 'Der hier ist nicht besonders spitz oder haltbar, scheint aber einen anderen Nutzen zu haben'
  },
  mining_barIridium: {
    name: 'Iridiumbarren',
    description: 'Was für seltsame Eigenschaften dieser hier hat...'
  },
  mining_barDarkIron: {
    name: 'Schwarzeisenbarren',
    description: ''
  },
  mining_ember: {
    name: 'Glut',
    description: 'Achtung, sie ist noch heiß!'
  },
  mining_resin: {
    name: 'Harz',
    description: 'Extrem klebriges Harz, womit die Belastungsfähigkeit von Spitzhacken erhöht wird'
  },
  mining_crystalGreen: {
    name: 'Grüner Kristall',
    description: 'Diese Kristalle sehen spitze aus! Ohne deinen Tiefengräber hättest du sie niemals gefunden'
  },
  mining_smoke: {
    name: 'Rauch',
    description: 'Das Atmen wird immer anstrengender, dieser Rauch ist dichter als gewöhnlicher Rauch'
  },
  mining_helium: {
    name: 'Helium',
    description: 'Auch bekannt als menschlicher Stimmverzerrer'
  },
  mining_neon: {
    name: 'Neon',
    description: 'Alles hier ist so hell...'
  },
  mining_argon: {
    name: 'Argon',
    description: ''
  },
  mining_krypton: {
    name: 'Krypton',
    description: ''
  },
  mining_xenon: {
    name: 'Xenon',
    description: ''
  },
  mining_radon: {
    name: 'Radon',
    description: ''
  },
  mining_crystalYellow: {
    name: 'Gelber Kristall',
    description: 'Diese Kristalle sehen auch spitze aus! Zum Glück hast du deinen Tiefengräber bereits bei dir'
  },
  village_coin: {
    name: 'Goldmünze',
    description: 'Münzen, die du durch den Verkauf von Lebensmitteln an die Dorfbewohner erhalten hast'
  },
  village_copperCoin: {
    name: 'Kupfermünze',
    description: 'Münzen, die du durch den Verkauf von hergestellten Gegenständen an die Dorfbewohner erhalten hast'
  },
  village_wood: {
    name: 'Holz',
    description: 'Baumstämme von naheliegenden Bäumen'
  },
  village_plantFiber: {
    name: 'Pflanzenfasern',
    description: 'Gras, kleine Pflanzen, Blätter, egal. Alles davon wird verwertet'
  },
  village_stone: {
    name: 'Stein',
    description: 'Kleine Steine, die deine Kreaturen gesammelt haben'
  },
  village_metal: {
    name: 'Metall',
    description: 'Deine Kreaturen haben dieses Metall beim Graben gefunden. Anscheinend ist den Boden unter diesem Dorf nicht voller Schrott'
  },
  village_gem: {
    name: 'Edelstein',
    description: 'Wertvoll und funkelnd, dieser Edelstein wurde von Sprengmeistern gefunden'
  },
  village_water: {
    name: 'Wasser',
    description: 'Nur einfaches, klares Wasser'
  },
  village_vegetable: {
    name: 'Gemüse',
    description: 'Frisches Gemüse aus regionalem Anbau'
  },
  village_fruit: {
    name: 'Obst',
    description: 'Süßes und saftiges Obst, die Dorfbewohner lieben es'
  },
  village_fish: {
    name: 'Fisch',
    description: 'Diese Fische stammen aus dem Fluss direkt neben dem Dorf'
  },
  village_grain: {
    name: 'Getreide',
    description: 'Getreide aus dem eigenen Dorf. Du denkst, dass man es vor dem Essen verarbeiten sollte, deinen Dorfbewohnern scheint das egal zu sein'
  },
  village_knowledge: {
    name: 'Wissen',
    description: 'Beobachte und lerne'
  },
  village_science: {
    name: 'Wissenschaft',
    description: 'Durch Experimente unter wissenschaftlichen Standards kannst du an Daten gelangen, die dir ein besseres Verständnis dieser Welt ermöglichen'
  },
  village_joy: {
    name: 'Freude',
    description: 'Erhalte Freude bei einer Zufriedenheit von über 125%. Mehr Zufriedenheit über diesem Wert erzeugt noch mehr Freude'
  },
  village_glass: {
    name: 'Glas',
    description: 'Achtung, nicht fallen lassen!'
  },
  village_faith: {
    name: 'Glaube',
    description: 'Deine Dorfbewohner sind sich sicher, dass die Dinge in der Zukunft besser werden'
  },
  village_blessing: {
    name: 'Segen',
    description: 'Die Hoffnungen deiner Dorfbewohner haben sich bewahrheitet! Dinge sind in der Zukunft besser! Es wird mit der Zeit einfacher!'
  },
  village_shares: {
    name: 'Aktien',
    description: 'Investiere, um mehr Geld zu verdienen!'
  },
  village_offering: {
    name: 'Opfergabe',
    description: 'Eine mysteriöse Opfergabe, für welche Ressourcen geopfert werden mussten'
  },
  village_hardwood: {
    name: 'Hartholz',
    description: 'Diese Holz wird von riesigen Bäumen gewonnen, welche Jahrhunderte zum Wachsen brauchen. Deren Holz ist hart, aber trotzdem noch biegsam'
  },
  village_oil: {
    name: 'Öl',
    description: 'Ein flexibler und wertvoller Rohstoff'
  },
  village_marble: {
    name: 'Marmor',
    description: 'Dieser wunderschöne Stein ist eine häufige Wahl in gehobenen Luxusbauten'
  },
  village_meat: {
    name: 'Fleisch',
    description: 'Diese Kühe hatten sicher ein wundervolles Leben... richtig?'
  },
  village_loot0: {
    name: 'Gewöhnliche Beute',
    description: 'Muss vorerst reichen...'
  },
  village_loot1: {
    name: 'Ungewöhnliche Beute',
    description: 'Ein wenig besser, da geht aber noch mehr!'
  },
  village_loot2: {
    name: 'Seltene Beute',
    description: 'Endlich etwas Vernünftiges'
  },
  village_loot3: {
    name: 'Epische Beute',
    description: 'Jetzt wird es langsam gut'
  },
  village_loot4: {
    name: 'Legendäre Beute',
    description: 'LEGENDÄR!'
  },
  village_loot5: {
    name: 'Mythische Beute',
    description: 'Und du dachtest sie wäre für immer verschollen'
  },
  village_acidVial: {
    name: 'Säurephiole',
    description: 'Sei vorsichtig!'
  },
  village_snowflake: {
    name: 'Schneeflocke',
    description: ''
  },
  village_chiliBundle: {
    name: 'Chilibündel',
    description: ''
  },
  village_gears: {
    name: 'Zahnräder',
    description: ''
  },
  horde_bone: {
    name: 'Knochen',
    description: 'Knöcherne Reste von besiegten Gegnern'
  },
  horde_monsterPart: {
    name: 'Monsterteil',
    description: 'Ein ekelhaftes Organ, was ab Zone 10 gefunden werden kann, wenn Gegner fehlen'
  },
  horde_corruptedFlesh: {
    name: 'Korruptes Fleisch',
    description: 'Das sieht überhaupt nicht gesund aus. Das ganze Stück Fleisch ist lila und zuckt stark'
  },
  horde_mysticalShard: {
    name: 'Mystische Scherbe',
    description: 'Voll mit unangetasteter Kraft'
  },
  horde_soulCorrupted: {
    name: 'Korrupte Seele',
    description: 'Diese Seelen sind verdorben, aber noch ist die Hoffnung nicht verloren. Sie können mit einem komplexen Ritual gerettet werden'
  },
  horde_soulEmpowered: {
    name: 'Verstärkte Seele',
    description: 'Ehemals verdorbene Seelen, welche durch ein komplexes Ritual gereinigt und bestärkt wurden'
  },
  horde_courage: {
    name: 'Courage',
    description: 'Mut ist eine wichtige Tugend, wenn man es mit einer nicht endenden Horde zu tun hat'
  },
  horde_crown: {
    name: 'Krone',
    description: 'Sie haben einst über die Türme geherrscht, sind jetzt aber entthront'
  },
  horde_towerKey: {
    name: 'Turmschlüssel',
    description: 'Ein seltener Schlüssel, der dir Zugang zu einem Turm gewährt'
  },
  horde_blood: {
    name: 'Blut',
    description: 'Iih!'
  },
  horde_lockpick: {
    name: 'Dietrich',
    description: 'Erlaubt es dir von einen bereits besiegten Boss Schmuckstücke zu erhalten. Nur für den Pirat'
  },
  farm_vegetable: {
    name: 'Gemüse',
    description: 'Iss dein Gemüse!'
  },
  farm_berry: {
    name: 'Beeren',
    description: 'Der fruchtbare Boden auf dem Bauernhof gibt den Beeren einen intensiven Geschmack'
  },
  farm_grain: {
    name: 'Getreide',
    description: 'Alles Getreide an einem Ort zu lagern ist in Ordnung, halte nur die Ratten fern'
  },
  farm_flower: {
    name: 'Blume',
    description: 'Du könntest stundenlang diese Blumen betrachten'
  },
  farm_gold: {
    name: 'Gold',
    description: 'Kleine Goldnuggets, die in der Erde vergraben waren'
  },
  farm_seedHull: {
    name: 'Saathülle',
    description: 'Eine leere pflanzliche Saathülle, die Saat selbst scheint zu fehlen'
  },
  farm_grass: {
    name: 'Gras',
    description: 'Das wirkt unnatürlich, Gras sollte nicht auf Pflanzen wachsen'
  },
  farm_petal: {
    name: 'Blütenblatt',
    description: 'Blütenblätter findet man auf allen Blumen, aber du sammelst nur die schönsten'
  },
  farm_bug: {
    name: 'Käfer',
    description: 'Deine Pflanzen locken alle Arten von Käfern an. Sie einzufangen ist nicht ganz so einfach'
  },
  farm_butterfly: {
    name: 'Schmetterling',
    description: 'Leicht und wunderschön, aber so schwer zu fangen'
  },
  farm_ladybug: {
    name: 'Marienkäfer',
    description: 'Sie sind zwar klein, aber mit etwas Glück findest du ganze Gruppen von ihnen'
  },
  farm_spider: {
    name: 'Spinne',
    description: 'Diese Kreaturen wirken zwar furchteinflößend, aber sie helfen dabei andere Insekten unter Kontrolle zu halten'
  },
  farm_bee: {
    name: 'Biene',
    description: 'Bienen sind häufig in Gärten anzutreffen. Lass sie einfach in Ruhe ihren Nektar sammeln'
  },
  farm_mysteryStone: {
    name: 'Mysterienstein',
    description: 'Was ist das? Welchen Nutzen hat es?'
  },
  farm_goldenPetal: {
    name: 'Goldenes Blütenblatt',
    description: 'Dieses extrem seltene Blütenblatt kann nur auf Rosen gefunden werden. Gerüchte behaupten, dass Rosen mit solchen Blütenblättern dunkler als gewöhnlich sind'
  },
  farm_smallSeed: {
    name: 'Kleine Saat',
    description: ''
  },
  gallery_beauty: {
    name: 'Schönheit',
    description: 'Dieses Bild wird nur schöner, je länger du malst'
  },
  gallery_converter: {
    name: 'Konverter',
    description: 'Erschaffe neue Farben, oder bereits bekannte'
  },
  gallery_inspiration: {
    name: 'Inspiration',
    description: 'Unbegrenzte Möglichkeiten'
  },
  gallery_package: {
    name: 'Paket',
    description: 'Was ist drin? Keiner weiß es! Wie eine kleine Überraschung'
  },
  gallery_red: {
    name: 'Rote Farbe',
    description: 'Male mit Leidenschaft'
  },
  gallery_redDrum: {
    name: 'Rote Farbtrommel',
    description: 'Eine gesamte Trommel voll mit roter Farbe'
  },
  gallery_orange: {
    name: 'Orange Farbe',
    description: 'Neue Farben, neue Welten'
  },
  gallery_orangeDrum: {
    name: 'Orange Farbtrommel',
    description: 'Diese Trommel ist mit oranger Farbe gefüllt'
  },
  gallery_yellow: {
    name: 'Gelbe Farbe',
    description: 'So kommt man schnell an Aufmerksamkeit'
  },
  gallery_yellowDrum: {
    name: 'Gelbe Farbtrommel',
    description: 'Diese Farbtrommel fällt schnell auf'
  },
  gallery_green: {
    name: 'Grüne Farbe',
    description: 'Sieht giftig aus, ist aber harmlos'
  },
  gallery_greenDrum: {
    name: 'Grüne Farbtrommel',
    description: 'Genau wie die Trommeln neben dem Atomkraftwerk'
  },
  gallery_blue: {
    name: 'Blaue Farbe',
    description: 'So ruhig, das wird eine gute Ergänzung für das Bild'
  },
  gallery_blueDrum: {
    name: 'Blaue Farbtrommel',
    description: 'Genau wie die anderen Trommeln, aber sie ist blau'
  },
  gallery_purple: {
    name: 'Lila Farbe',
    description: 'Mysteriös und unbekannt'
  },
  gallery_purpleDrum: {
    name: 'Lila Farbtrommel',
    description: ''
  },
  "gallery_deep-orange": {
    name: 'Rotorange Farbe',
    description: 'Diese Farbe wirkt neu, aber auch bekannt'
  },
  "gallery_deep-orangeDrum": {
    name: 'Rotorange Farbtrommel',
    description: ''
  },
  gallery_amber: {
    name: 'Goldene Farbe',
    description: ''
  },
  gallery_amberDrum: {
    name: 'Goldene Farbtrommel',
    description: ''
  },
  "gallery_light-green": {
    name: 'Hellgrüne Farbe',
    description: ''
  },
  "gallery_light-greenDrum": {
    name: 'Hellgrüne Farbtrommel',
    description: ''
  },
  gallery_teal: {
    name: 'Türkise Farbe',
    description: ''
  },
  gallery_tealDrum: {
    name: 'Türkise Farbtrommel',
    description: ''
  },
  "gallery_light-blue": {
    name: 'Hellblaue Farbe',
    description: ''
  },
  "gallery_light-blueDrum": {
    name: 'Hellblaue Farbtrommel',
    description: ''
  },
  gallery_pink: {
    name: 'Pinke Farbe',
    description: ''
  },
  gallery_pinkDrum: {
    name: 'Pinke Farbtrommel',
    description: ''
  },
  gallery_motivation: {
    name: 'Motivation',
    description: ''
  },
  gallery_mysteryShape: {
    name: 'Mysterienform',
    description: 'Was ist diese Form? Sie sieht seltsam aus, als würde sie nicht in diese Dimension gehören'
  },
  gallery_circle: {
    name: 'Kreis',
    description: ''
  },
  gallery_rectangle: {
    name: 'Rechteck',
    description: ''
  },
  gallery_triangle: {
    name: 'Dreieck',
    description: 'Achtung, sie sind gefährlich'
  },
  gallery_star: {
    name: 'Stern',
    description: ''
  },
  gallery_ellipse: {
    name: 'Ellipse',
    description: ''
  },
  gallery_heart: {
    name: 'Herz',
    description: '<3'
  },
  gallery_square: {
    name: 'Quadrat',
    description: ''
  },
  gallery_octagon: {
    name: 'Achteck',
    description: ''
  },
  gallery_pentagon: {
    name: 'Fünfeck',
    description: 'Eine Form, kein Gebäude'
  },
  gallery_hexagon: {
    name: 'Sechseck',
    description: ''
  },
  gallery_cash: {
    name: 'Geld',
    description: 'Leicht verdientes Geld!'
  },
  school_book: {
    name: 'Buch',
    description: 'Es ist nicht einfach, diese schweren Bücher zu tragen'
  },
  school_goldenDust: {
    name: 'Goldstaub',
    description: 'Er strahlt eine seltsame Energie aus, als ob er die Zeit selbst verändern könnte'
  },
  school_examPass: {
    name: 'Prüfungspass',
    description: 'Seltsam, bei unserer alten Schule haben wir sowas nicht gebraucht. Hier sind sie nötig, um eine Prüfung zu schreiben'
  },
  card_shinyDust: {
    name: 'Glitzerstaub',
    description: ''
  },
  treasure_fragment: {
    name: 'Fragment',
    description: 'Zerbrochenes Stück eines Schatzes'
  }
};
